

export class Competitors {

  dealerId: string = "";
  businessId: string = "";
  enterpriseIdComp: string = "";
  competitors_businessId: string = "";
  competitorsName: string = "";;
  phone: string = "";
  zip: string = "";
  disabled!: boolean;
  deleteAction: string = "";
  countryCode: string = "";
  //status: string = "";

  constructor(data: Competitors){
    Object.assign(this, data);
    //this.disabled = this.status === "Closed"
  }

}